// 40-3941 交付稿首页专用数据。素材由接入方按原哈希名复制到 public/image/home-redesign/。
import { module } from '../constant.js'

export const guestHomeLinks = {
  register: 'https://www.quectel.com.cn/register',
  contact: 'https://www.quectel.com.cn/contact?pro=QUnlvIDmlL7lubPlj7A&tagStr=NGExMDllYjU2NDc3OGZjZg&proType=QUnlvIDmlL7lubPlj7A',
  playground: 'https://www.quectel.com.cn/contact?pro=QUkgUGxheWdyb3VuZA&tagStr=NGExMDllYjU2NDc3OGZjZg',
  partners: 'https://www.quectel.com.cn/strategic-partners',
  algorithms: '/ai-open-platform/algostore',
}

export const heroImage = '22eaafa2b4c83d3467e6857c.png'
export const footerLogo = '44c283ec4d331a8c7f51193c.svg'
export const wechatImage = 'c36b502c42045bfa064c5da3.png'

export const capabilities = [
  { title: '丰富的端侧大模型库', image: '9e2538ec9cb6cb69563461e8.svg', desc: '支持Qwen、DeepSeek、Llama、RWKV等主流AI大模型，打通场景化模型微调、适配、量化、转换、部署全流程' },
  { title: '异构算力优化', image: 'f01139ad3608f8b503a9d7b6.svg', desc: '充分释放 CPU/ GPU/ NPU 的算力，提升端侧推理速度' },
  { title: '全链路音频算法能力', image: '801bcbd1b5a80d0a8159a66d.svg', desc: '覆盖VAD人声检测、AEC回声消除、ANS音频降噪、KWS语音唤醒和指令识别、SSL声源定位、VPR声纹识别、ASR语音识别、TTS语音合成等' },
  { title: '强大的AI视觉算法能力', image: '9c83251c78f781fc4125b030.svg', desc: '涵盖从数据清洗、模型选择、模型训练、边缘部署到应用开发的全流程，成功助力众多客户实现多样化的AI业务场景' },
]

export const businesses = [
  { title: '机器人', image: 'b262021936c79d8a5e162fc1.jpg', href: '/ai-open-platform/solutions/robrain', desc: '提供人形机器人、服务机器人、按摩机器人等机器人产品的AI解决方案，实现端云协同的智能交互。' },
  { title: '智慧零售', image: '24007c33c9b3080c314459a3.jpg', href: '/ai-open-platform/solutions/smart_scale', desc: '通过AI视觉算法与深度学习，实现商品精准自动识别与无感支付，让购物体验更智能。' },
  { title: '智能语音', image: 'fd5a9b191fe698df75632e7e.jpg', href: '/ai-open-platform/solutions/audio_modules', desc: '通过集成模组硬件，搭载全链路音频算法，让智能终端能够敏锐地“听到”与精准地“理解”用户。' },
  { title: '智能玩具', image: 'bcd6e800119de12f0d9309b8.jpg', href: '/ai-open-platform/solutions/smart_toys', desc: '提供一站式AI玩具解决方案，助力传统玩具突破单向输出的局限，真正化身为可对话、可共情、可持续陪伴的“贴心伙伴”。' },
]

export const advantages = [
  { title: '算法领先', desc: '汇聚了包括视觉、音频等多领域的先进AI算法，以上的核心算法经客户实际项目验证，并且不断迭代创新。' },
  { title: '硬件适配', desc: '算法全面覆盖Qualcomm、Unisoc、Rockchip、MediaTek等主流芯片，消除选型顾虑。' },
  { title: '深度定制', desc: '全球化布局与客户服务网络，针对差异化业务需求提供深度定制化服务，打造专属解决方案。' },
]

export const algorithms = [
  { title: '情绪识别', tag: '人脸检测', image: 'home/emotion.jpg', desc: '基于面部表情等多维分析，精准判断人的情绪状态。', scene: '满意度分析', href: '/ai-open-platform/algostore/face_emotion?id=5' },
  { title: '人脸关键点', tag: '人脸检测', image: 'home/face_landmarks.jpg', desc: '检测人脸五官与轮廓关键点及位置，包括面部轮廓、眼、眉、唇、鼻等核心区域。', scene: '3D建模', href: '/ai-open-platform/algostore/face_landmarks_detection?id=2' },
  { title: '手势识别', tag: '人体识别', image: 'home/body_gesture.jpg', desc: '通过图像识别技术，捕捉用户手势指令，以进行对应操作。', scene: '手势交互', href: '/ai-open-platform/algostore/body_gesture_recognition?id=15' },
  { title: '驾驶行为分析', tag: '人体识别', image: 'home/driver.jpg', desc: '依托图像识别技术，实时分析驾驶员操作及状态。', scene: '疲劳驾驶预警', href: '/ai-open-platform/algostore/body_driver_monitoring?id=13' },
]

export const playgroundFeatures = [
  { title: '丰富算法选择', desc: '全面兼容算法超市 AlgoStore 中的 AI 视觉、AI 音频等多元算法，提供丰富的 AI 能力选择' },
  { title: '多元硬件适配', desc: '无缝适配 AI BOX、Quectel Pi SBC 系列单板电脑等硬件，提供多元硬件平台选择' },
  { title: '开箱即用体验', desc: '无需复杂开发与调试，真正实现开箱即用，加速从创新想法到 AI 应用落地周期' },
]

export const openclawFeatures = [
  { title: '算力强劲', desc: '提供持续、可靠的本地计算资源，既能支撑 AI 实时决策与任务执行，又能实现性能与功耗的精准平衡。' },
  { title: '成本友好', desc: '仅需Mac mini一半的价格，搭配灵活可扩展的存储配置，完美满足 OpenClaw 本地运行、文件读写与定时任务需求，且预装操作系统，可快速上手部署，实现“低门槛”拥抱AI。' },
  { title: '网络灵活', desc: '支持多种无线通信方式，即便身处工厂车间、户外园区等弱信号场景，也能保障网络稳定连接，场景无死角。' },
  { title: '接口丰富', desc: '集成多元化接口，可直接连接打印机、麦克风、监测设备及其他传感器，让 OpenClaw 的能力从 “操控软件” 延伸到 “联动硬件”，极大地拓展了应用边界。' },
]

export const products = [
  { title: 'Quectel Pi H1', image: 'enology/Pi-H1.jpeg', href: 'https://www.quectel.com.cn/product/quectel-pi-h1', desc: '面向物联网和智能硬件的综合性开发平台，集成多种通信模组、传感器及外设接口，助力开发者快速完成原型搭建与商业化落地。' },
  { title: 'Quectel Pi M1', image: 'enology/M1.jpeg', href: 'https://www.quectel.com.cn/product/quectel-pi-m1', desc: '接口配置丰富，广泛适配边缘计算、机器人、工控设备、多媒体终端、数字广告牌、智能安全、工业级PDA等场景，全面覆盖AIoT领域。' },
]

// 保持交付稿顺序，桌面端为 9 / 9 / 1；修正旧 Partner 中 Infineon 的重复协议拼写。
export const partners = [
  { name: 'ASR', image: 'e0da56b98bfd0b88fa0a0a8e.png', href: 'https://www.asrmicro.com/asrweb/' },
  { name: 'Infineon', image: '80d88370c187ecdd910b2dc9.png', href: 'https://www.infineon.com/' },
  { name: 'MediaTek', image: '40a8b1dd39adacfcdf068eea.png', href: 'https://mediatek.com/' },
  { name: 'Qualcomm', image: '9439f8afc51caab3a9ce321a.png', href: 'https://qualcomm.com/' },
  { name: 'SONY', image: 'ca19e85683b5a87423893a88.png', href: 'https://www.sony.net/' },
  { name: 'UNISOC', image: '4b6c6542c20c77e858d9b4fa.png', href: 'https://unisoc.com/' },
  { name: 'aws', image: 'ce6978c1fd6b97bf6d651166.png', href: 'https://aws.amazon.com/' },
  { name: 'Azure', image: '2ac8c3fdc43150579ece681e.png', href: 'https://azure.microsoft.com/' },
  { name: 'ERICSSON', image: '00d127ed935901c42f8c6e82.png', href: 'https://www.ericsson.com/en' },
  { name: 'NVIDIA', image: '5589bbcc9e2d4a8c98f79785.png', href: 'https://www.nvidia.com/' },
  { name: 'ST', image: 'ce267cdbb55bdf52682c8dd9.png', href: 'https://www.st.com/' },
  { name: '3GPP', image: '80aeb013fe8550ef6eca432f.png', href: 'https://www.3gpp.org/' },
  { name: '450 alliance', image: 'd3922da246dec0eae5eeba6a.png', href: 'https://450alliance.org/' },
  { name: '5GAA', image: 'dff839d8f6669d829a37b285.png', href: 'https://5gaa.org/' },
  { name: 'CSA', image: '89364c230573e8e86fc06f03.png', href: 'https://csa-iot.org/' },
  { name: 'RWKV', image: '582eec08ca18ddb066a9dccf.jpg', href: 'https://www.rwkv.cn/' },
  { name: '火山引擎', image: '8372019349ee95bf611ca20c.png', href: 'https://www.volcengine.com/' },
  { name: '千问', image: '929e0af6df18a007dcdaa022.png', href: 'https://www.qianwen.com/' },
  { name: 'JoyAI', image: '2745986289d51a34a925c3ef.png', href: 'https://jdai.jd.com/yanxi' },
]

export const updates = [
  { title: '小机身，蕴藏大能量！Animator 让毛绒玩具「活」起来', category: '产品研发', date: '2026-01-22', href: 'https://www.quectel.com.cn/news-and-pr/animator-smart-movement-box' },
  { title: '当爆火OpenClaw遇上移远AI Playground ，你的「全能AI员工」有了最佳主场', category: '产品研发', date: '2026-02-02', href: 'https://www.quectel.com.cn/news-and-pr/openclaw-ai-playground' },
  { title: '【白皮书】“端云＋多模态”新范式：《移远通信AI大模型技术方案白皮书》重磅发布', category: '白皮书', date: '2025-07-28', href: 'https://www.quectel.com.cn/tech-features/quectel-publishes-ai-large-model-solution-whitepaper' },
]

// 新旧公共底栏共用官网分组，不能再次把分组数据当成单条链接拼装。
export const footerColumns = module

export const policies = [
  { name: 'Cookie政策', href: 'https://www.quectel.com.cn/cookies-policy' },
  { name: '隐私协议', href: 'https://www.quectel.com.cn/privacy-policy' },
  { name: '服务协议', href: 'https://www.quectel.com.cn/terms-of-service' },
]

// 完整且去重的首页素材清单：含目录的路径复用原首页高清图，其他素材位于 home-redesign。
export const guestHomeAssets = [
  heroImage, ...capabilities.map(item => item.image), ...businesses.map(item => item.image),
  ...algorithms.map(item => item.image), ...products.map(item => item.image),
  ...partners.map(item => item.image), footerLogo, wechatImage,
]
